import React from "react";
import { ConfigProvider } from "antd";
import useTranslation from "utils/hooks/useTranslation";

interface RadioGroupProps {
  name?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ name = "APP_IS_HELPFULL", value, onChange }) => {
  const { t } = useTranslation();

  const options = [
    { value: "0", label: t("VERY_NOT_SATISFYING") },
    { value: "1", label: t("NOT_SATISFYING") },
    { value: "2", label: t("SATISFYING") },
    { value: "3", label: t("VERY_SATISFYING") }
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <ConfigProvider>
      <group data-space-vertical="10" role="radiogroup" aria-label="Satisfaction level" data-max-length="700">
        {options.map((option) => (
          <label
            key={option.value}
            radio=""
            data-custom=""
            className=""
            data-name="satisfaction"
            data-length="autofit"
            data-fit="1"
            aria-describedby="«r5t»"
          >
            <input //NOSONAR
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={handleChange}
              aria-hidden="true"
            />
            <box>
              <check></check>
              <ink></ink>
            </box>
            <text>{option.label}</text>
            <separator data-horizontal=""></separator>
          </label>
        ))}
      </group>
    </ConfigProvider>
  );
};
